import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { Account } from "./myProfilesWithData";

export interface MyProfilesResponse extends BackendResponse {
  result: Account[];
}

export interface MyProfilesParameters extends NextApiParams {}

export const myProfiles = withNextApi<MyProfilesResponse, MyProfilesParameters>(
  "/auth/MyProfiles",
  {
    method: "GET",
  }
);
